import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import { InputLabel, ListSubheader, MenuItem, Select } from "@mui/material";

import type { Control, FieldValues, Path, RegisterOptions } from "react-hook-form";

// Cada opción listada (staffing o proyecto) solo necesita id (value) y name (texto);
// no se importa el DTO real de cada call site para no acoplar este selector genérico
// a un dominio específico.
export interface SelectProjectOption {
  id?: number | string;
  name?: string;
}

export interface SelectProjectRegisterHourProps<T extends FieldValues = FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  rules?: RegisterOptions<T>;
  defaultValue: unknown;
  listValue?: SelectProjectOption[] | null;
  listStaffing?: SelectProjectOption[] | null;
  listProjects?: SelectProjectOption[] | null;
  disabled?: boolean;
}

// Selector de proyecto para registrar horas. Agrupa los proyectos en dos
// secciones: "Staffings" y "Proyectos", separadas por ListSubheader.
export const SelectProjectRegisterHour = <T extends FieldValues = FieldValues,>({
  control,
  name,
  label,
  rules,
  defaultValue,
  listStaffing,
  listProjects,
  disabled,
}: SelectProjectRegisterHourProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as never}
      rules={rules}
      render={({ field }) => (
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">{label}</InputLabel>
          <Select
            {...field}
            label={label}
            defaultValue={defaultValue as never}
            id="grouped-select"
            disabled={disabled}
          >
            {listStaffing && listStaffing.length > 0 && (
              <ListSubheader>Staffings</ListSubheader>
            )}
            {listStaffing?.map((value, index) => (
              <MenuItem value={value.id} key={index}>
                {value.name}
              </MenuItem>
            ))}
            {listProjects && listProjects.length > 0 && (
              <ListSubheader>Proyectos</ListSubheader>
            )}
            {listProjects?.map((value, index) => (
              <MenuItem value={value.id} key={index}>
                {value.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
};
